import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import _ from 'lodash'
import {
  dateConverter,
  booleantoString,
  formatFileSize,
  capitalize,
  getLocalizedContent,
  checkEmailMaskBeforeRender,
} from '../helper'
import { fileOptionsConstants } from '../constants/fileOptions'
import { shareConstants } from '../constants/shareConstants'
import { constants } from '../constants/constants'
import serverData from '../utils/server-data'

class RenderProperties extends Component {
  constructor(props, context) {
    super(props, context)
  }

  renderproperty = (item, key) => {
    const user = serverData.user
    if (key === 'size') {
      return formatFileSize(item[key] ? item[key] : 0)
    } else if (key === 'modifiedDate' || key === 'createdDate') {
      const date = item[key].split(' ')
      return dateConverter(`${date[0]} ${date[1]}`)
    } else if (typeof item[key] === 'boolean') {
      return booleantoString(item[key])
    } else if (key === 'fileType') {
      return getLocalizedContent(`filter.${item[key]}`)
    } else if (
      key === 'sharedBy' &&
      _.has(item, 'enableEmailMask') &&
      item.enableEmailMask
    ) {
      return user.accType === constants.AdhocUser
        ? shareConstants.EmailIdToMaskSenderAddress
        : item.sharedBy
    }
    return checkEmailMaskBeforeRender(item, key)
  }

  renderProperties = () => {
    return (
      <div className="overlay__container">
        <div className="overlay__content">
          <div
            className="overlay__action-close"
            onClick={() => this.props.closePropertyBox()}
          >
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close" />
          </div>
          <div className="overlay__section">{this.renderBasicProperties()}</div>
        </div>
      </div>
    )
  }

  renderBasicProperties = () => {
    const { showPropertiesForItem } = this.props
    return (
      <dl className="properties__informationBody">
        {fileOptionsConstants.Properties.map((item) => {
          return (
            <div className="description__container" key={item.key}>
              <dt className="ppvx_text--md">
                <Message id={`details.${item.localizeId}`} />
              </dt>
              <dd className="ppvx_text--md">
                {this.renderPropertyValue(showPropertiesForItem, item.key)}
              </dd>
            </div>
          )
        })}
        {this.renderSharedInformation(showPropertiesForItem)}
      </dl>
    )
  }

  renderSharedInformation = (showPropertiesForItem) => {
    return showPropertiesForItem.permission &&
      showPropertiesForItem.sharedBy ? (
      <div>
        {' '}
        {this.renderSharedInfo(
          'sharedBy',
          this.renderproperty(showPropertiesForItem, 'sharedBy'),
        )}
        {this.renderSharedInfo(
          'permission',
          getLocalizedContent(
            shareConstants.localizeIdForPermissions[
              shareConstants.FilePermissionFromServer[
                showPropertiesForItem.permission
              ]
            ],
          ),
        )}
      </div>
    ) : (
      this.renderSharedInfo(
        `shared${capitalize(showPropertiesForItem.fileType)}`,
        showPropertiesForItem.isShared
          ? getLocalizedContent('buttons.yes')
          : getLocalizedContent('buttons.no'),
      )
    )
  }

  renderSharedInfo = (key, value) => {
    return (
      <div className="description__container">
        <dt className="ppvx_text--md">
          <Message id={`details.${key}`} />
        </dt>
        <dd className="ppvx_text--md flexSpaceBetween shared__status">
          {value}
        </dd>
      </div>
    )
  }

  renderPropertyValue = (showPropertiesForItem, key) => {
    const value = this.renderproperty(showPropertiesForItem, key)
    return (
      <div className="tooltip" onMouseOver={(e) => this.props.onMouseOver(e)}>
        {value.length > 35 ? `${value.substring(0, 35)}...` : value}
        {value.length > 35 && <span className="tooltiptext">{value}</span>}
      </div>
    )
  }

  render() {
    return <div>{this.renderProperties()}</div>
  }
}

export default RenderProperties
